//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
import ImgWrap from '@/components/business/img_wrap'
import type_name from '@/components/mixins/building_ranking'
export default {
    data () {
        return {
            showTip: true
        }
    },
    mixins: [
        type_name
    ],
    components: {
        ImgWrap
    },
    computed: {
        show_vr () {
            const { vr_resource } = this.item || {}
            return vr_resource && vr_resource.vr_photo_url
        },
        headimg () {
            const { photo_url, vr_resource, cover_photo_url } = this.item
            if (photo_url) {
                return photo_url
            }
            if (this.show_vr) {
                return vr_resource.vr_photo_url
            }
            return cover_photo_url
        },
        center() {
            return (this.item.price_desc_arr && this.item.price_desc_arr.length === 0)
                || (this.item.tags && this.item.tags.length === 0)
        }
    },
    onPageScroll () {
        if (this.showTip) {
            this.showTip = false
        }
    },
    methods: {
        closeTip () {
            this.showTip = false
        },
        goDetail () {
            const { log_id, position, href } = this.item
            const { index } = this
            if (log_id) {
                Service.interestingEvent({
                    event: 'click',
                    interesting_id: log_id,
                    pos: index,
                    pos_name: position
                })
            }
            this.$router.push({
                path:`${href}&status=摇号剩余`
            })
        },
        goComments () {
            const { id, name } = this.item
            this.$router.push({
                path:'/building/comments?building_id=' + id + '&name=' + name
            })
        }
    },
    props: {
        item: Object,
        index: Number,
        classname: String
    }
}
